<template>
	<component
		v-if="isVisible"
		:is="tag"
		:style="styles"
		@mouseenter="mouseEnter"
		@mouseleave="mouseLeave"
		@mousedown="mouseDown"
		@mouseup="mouseUp"
	>
		<slot />
	</component>
</template>

<script setup>
	import { defineEmits, defineProps, nextTick, ref, toRefs, watch } from 'vue';
	import { useElementStyles } from '@/composables/useElementStyles';

	const emit = defineEmits(['changeActive']);

	const props = defineProps({
		active: {
			type: Boolean,
			default: false,
		},
		tag: {
			type: String,
			default: 'div'
		},
		settings: {
			type: Object,
			required: true
		},
		disableHover: {
			type: Boolean,
			default: false
		}
	});

	const { settings, active } = toRefs(props);
	const { styles, isHovered, isActive } = useElementStyles(settings, active);
	const isVisible = ref(true);

	watch([isActive, isHovered], (newValue) => {
		emit('changeActive', (newValue[0] || newValue[1]));
	});

	watch(
		() => props.settings?.backgroundImage,
		async () => {
			isVisible.value = false;
			await nextTick();
			isVisible.value = true;
		}
	);

	function mouseEnter() {
		if (props.disableHover || props.tag !== 'button') return;

		isHovered.value = true;
	}

	function mouseLeave() {
		if (props.disableHover || props.tag !== 'button') return;

		isHovered.value = false;
		isActive.value = false;
	}

	function mouseDown() {
		if (props.disableHover || props.tag !== 'button') return;

		isActive.value = true;
	}

	function mouseUp() {
		if (props.disableHover || props.tag !== 'button') return;

		isActive.value = false;
	}
</script>